/*
* Created on Mar 03, 2021
* @author: Adam Cheng <adamcheng@qnap.com>
*/
import { useState } from 'react';
import ModelWizardComponent from "../../common/ModalComonent/ModelWizardComponent";
import OrganizationFormComponent from "./OrganizationFormComponent";
import OrganizationGroupFormComponent from "./OrganizationGroupFormComponent";
import OrganizationInviteAdminComponent from "./OrganizationInviteAdminComponent";
import {useReducerAsync} from "use-reducer-async";
import {useTranslation} from "react-i18next";
import {useOrganizationApi} from "../../../hook/OrganizationAPIHook";
import {useOrganizationListRefresh} from "../../../context/OrganizationContext";
import {isValidCountry} from "../../../service/common";
import {useCountryList} from "../../../context/CountryListContext";


const wrapAsync = (dispatch) => {
    return (action) => {
        if (action instanceof Function) {
            return action(dispatch);
        }
        return dispatch(action);
    }
}

const OrganizationWizardComponent = ({openModal, closeModal, doRefresh, setOrgList}) => {
    // for organization creation
    const {t} = useTranslation();
    const {OrganizationAPI} = useOrganizationApi();
    const {list: countryList} = useCountryList();
    const [orgInput, setOrgInput] = useState({});
    const [groupInput, setGroupInput] = useState({});
    const {setRefresh:refreshOrganizationList} = useOrganizationListRefresh();

    const onModalClose = () => {
        doRefresh((prevRefresh)=>prevRefresh + 1);
        closeModal();
    };

    const init_wizard_data = {
        current_step: 0,
        // disable_next_button: true,
        steps: [
            {
                label: t('@Organization information@'),
                next_button_label: t('@Create@'),
                next_action: (alert) => {
                    dispatch({type: 'createOrganization', payload:{alert}});
                },
                next_action_validation: (org_state) => {
                    // dispatch({type: 'valid_createOrganization_next_button'})
                    if (org_state?.orgInput) {
                        for (const [key, value] of Object.entries(org_state.orgInput) ) {
                            if (value.error?.length > 0) {
                                return false;
                            }

                            if (value.required && (!value.value || value.value?.length <= 0)) {
                                return false;
                            }
                        }
                        return true;
                    }
                }
            },
            {
                label: t('@Create group@'),
                next_button_label: t('@Invite Members@'),
                // prev_button_label: t('@Back@'),
                next_action_validation: (org_state) => {
                    // return org_state?.groups?.length > 0;
                    return true;
                }
            },
            {
                label: t('@Invite administrator@'),
                next_button_label: t('@Finish@'),
                prev_button_label: t('@Back@'),
                next_action_validation: (org_state) => {
                    return true;
                },
                next_action: (alert) => {
                    dispatch({type: 'inviteAdmin', payload:{alert}});
                }
            }
        ]
    }



    const dispatch_handler = (org_state, action) => {
        switch (action.type) {
            case 'next':
                if (action?.payload?.organization_id) {
                    return {
                        ...org_state,
                        current_step: org_state.current_step + 1,
                        organization_id: action.payload.organization_id
                    }
                }
                return {...org_state, current_step: org_state.current_step + 1}
            case 'prev':
                return {...org_state, current_step: org_state.current_step - 1}
            case 'valid_createOrganization_next_button':
                for (const [key, value] of Object.entries(org_state.orgInput) ) {
                    if (value.error?.length > 0) {
                        return {...org_state, disable_next_button: false};
                    }

                    if (value.required && (!value.value || value.value?.length <= 0)) {
                        return {...org_state, disable_next_button: false};
                    }
                }
                return {...org_state, disable_next_button: true};
            case 'inviteAdmin_toggleGroup':
                const _groups = org_state.groups.map((g)=>{
                    if (g.organization_group_id === action.payload.id) {
                        g.checked = action.payload.checked;
                    }
                    return g;
                });
                return {...org_state, groups: _groups}
            case 'inviteAdmin_uncheck_groups':
                const clear_groups = org_state.groups.map((g)=>{
                    g.checked = false;
                    return g;
                });
                return {...org_state, groups: clear_groups}
            case 'inviteAdmin_setInviteList':
                return {...org_state, inviteList: action.payload}
            case 'inviteAdmin_setRole':
                return {...org_state, role: action.payload}
            case 'getUpdate':
                if (action.payload?.orgInput) {
                    return {...org_state, orgInput: orgInput}
                }
                else if (action.payload?.groups) {
                    return {...org_state, groups: action.payload.groups}
                }
                return org_state
            case 'setAlertFunction':
                return {...org_state, alert: action.payload.alert}
            default:
                return org_state
        }
    }

    const asyncDispatchHandler = {
        createOrganization: ({dispatch, getState}) => async (action) => {
            const cur_state = getState();
            let input_data = {}
            for ( const [key, value] of Object.entries(cur_state.orgInput) ) {
                if (value.value) {
                    input_data[key] = value.value
                }
            }
            if (!isValidCountry(input_data.country, countryList)) {
                // surface error via the existing input-error mechanism for this wizard step
                action.payload.alert(true, 'error', 'invalid_country', t('@Invalid country@'));
                return;
            }
            try {
                const count = await OrganizationAPI.get('organization/count', null);
                if (count?.result > window._env_.REACT_APP_MAX_ORGANIZATION) {
                    action.payload.alert(true, 'error', 1060033, 'You have reached the maximum limit of 50 organizations for your QNAP ID.');
                    return;
                }
                const res = await OrganizationAPI.post('organization', null, input_data);
                if (res) {
                    // setNewOrgId(res.result.organization_id);
                    let new_org_list = JSON.parse(window.localStorage.getItem('new_org_list')) || [];
                    if (! new_org_list.includes(res.result.organization_id)) {
                        new_org_list.push(res.result.organization_id);
                    }
                    window.localStorage.setItem('new_org_list', JSON.stringify(new_org_list));
                    dispatch({type: 'next', payload:{organization_id: res.result.organization_id}});
                    refreshOrganizationList(prev => prev + 1)
                    // return {...org_state, organization_id: res.result.organization_id}
                }
            }
            catch (err) {
                action.payload.alert(true, 'error', err.code, err.message);
                console.log(err);
            }
        },
        createOrganizationGroup: ({dispatch, getState}) => async (action) => {
            const cur_state = getState();
        },
        inviteAdmin: ({dispatch, getState}) => async (action) => {
            const cur_state = getState();
            if (cur_state?.inviteList?.filter(i => i.value !== '')?.length > 0) {
                let input_data = {
                    organization_id: cur_state.organization_id,
                    users: cur_state.inviteList.map((i)=>{
                        let invite = {
                            qid: i.value,
                            role: cur_state.role,
                            groups: cur_state?.groups?.filter((g) => g.checked).map((g)=>g.organization_group_id) || []
                        };
                        return invite;
                    })
                };
                try {
                    await OrganizationAPI.post(`organization_invitation`, null, input_data);
                }
                catch (err) {
                    action.payload.alert(true, 'error', err.response?.data?.code, err.response?.data?.message);
                    console.log(err);
                    return;
                }
            }

            doRefresh((prevRefresh)=>prevRefresh + 1);
            closeModal();
        }
    }

    const [state, dispatch] = useReducerAsync(dispatch_handler, init_wizard_data, asyncDispatchHandler);
    // const [state, dispatch] = useReducer(dispatch_handler, init_wizard_data);


    return (
        <ModelWizardComponent isOpen={openModal} wizard_data={state} disPatcher={dispatch} onClose={onModalClose} title={t('@Create organization@')}>
            <div className="dialog-content">
                { state.current_step === 0 &&
                    <OrganizationFormComponent input={orgInput} setInput={setOrgInput} disPatcher={dispatch}/>
                }
                { state.current_step === 1 &&
                    <OrganizationGroupFormComponent input={groupInput} setInput={setGroupInput} newOrgId={state.organization_id} dispatcher={dispatch} state={state}/>
                }
                {state.current_step === 2 &&
                    <OrganizationInviteAdminComponent newOrgId={state.organization_id} wizard_data={state} disPatcher={dispatch}/>
                }
            </div>
        </ModelWizardComponent>
    );
};

export default OrganizationWizardComponent;